// extracted by mini-css-extract-plugin
module.exports = {"productPage":"ProductPageV2_productPage__QbGhs","content":"ProductPageV2_content__en6TA"};